import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientAcumatica: string;

export interface AcumaticaProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
}

class AcumaticaProgressUpdate {
    acumaticaProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientAcumaticad = (typeof isClientAcumatica === "undefined") ? false : isClientAcumatica;

        if(isClientAcumaticad == 'true'){
            this.acumaticaProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Acumatica::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `acumatica_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Acumatica Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Acumatica Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    updateProgress(data: AcumaticaProgressChannelData) {
        console.log(data);
        $("#acumatica_sync").show();
        $("#acumatica_sync_btn").hide();
        $("#last_update").hide();
        $("#acumatica_sync_progress").text(data.message);
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#acumaticaProgressLabel").text(`${data.progress}%`)
        $(".currentStatusDesc_Category").text(`${data.message}`)
        var bat = $(".categ_acumatica_sync").length == 1 || $(".sync_to_acumatica").length == 1
        if (!data.inProgress && data.success && bat){
            $(".progress-spin").hide();
            $(".fail-img").hide();
            $(".doSyncBtn").hide();
            $(".acumaticaSyncBtn").show();
            $(".acumaticaSyncBtn").removeAttr('disabled')
            $(".previewSyncBtn").removeAttr('disabled')
            $('.success-img').removeClass("hide");
            $(".success-img").show();
            $(".currentStatusDesc_Category").text('Synchronization preview complete')
        }
        if (!data.inProgress && data.success && !bat) {
            this.refresh();
// need to check
            $("#acumatica_sync_btn").show();
            $("#last_update").show();

        }
        if (!data.success) {
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("compare_v2", () => {
        const t = new AcumaticaProgressUpdate();
    });
}
